/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface V1DatalakeItem
 */
export interface V1DatalakeItem {
    /**
     *
     */
    id: string
    /**
     *
     */
    corellationId?: string
    /**
     *
     */
    kind: string
    /**
     *
     */
    version: string
    /**
     *
     */
    userId?: string
    /**
     *
     */
    orgId?: string
    /**
     *
     */
    isPublic?: boolean
    /**
     * JSON string of data
     */
    data: string
    /**
     * Unix timestamp
     */
    created?: number
}

/**
 * Check if a given object implements the V1DatalakeItem interface.
 */
export function instanceOfV1DatalakeItem(
    value: object
): value is V1DatalakeItem {
    if (!('id' in value) || value['id'] === undefined) return false
    if (!('kind' in value) || value['kind'] === undefined) return false
    if (!('version' in value) || value['version'] === undefined) return false
    if (!('data' in value) || value['data'] === undefined) return false
    return true
}

export function V1DatalakeItemFromJSON(json: any): V1DatalakeItem {
    return V1DatalakeItemFromJSONTyped(json, false)
}

export function V1DatalakeItemFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1DatalakeItem {
    if (json == null) {
        return json
    }
    return {
        id: json['id'],
        corellationId:
            json['corellationId'] == null ? undefined : json['corellationId'],
        kind: json['kind'],
        version: json['version'],
        userId: json['userId'] == null ? undefined : json['userId'],
        orgId: json['orgId'] == null ? undefined : json['orgId'],
        isPublic: json['isPublic'] == null ? undefined : json['isPublic'],
        data: json['data'],
        created: json['created'] == null ? undefined : json['created']
    }
}

export function V1DatalakeItemToJSON(json: any): V1DatalakeItem {
    return V1DatalakeItemToJSONTyped(json, false)
}

export function V1DatalakeItemToJSONTyped(
    value?: V1DatalakeItem | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        id: value['id'],
        corellationId: value['corellationId'],
        kind: value['kind'],
        version: value['version'],
        userId: value['userId'],
        orgId: value['orgId'],
        isPublic: value['isPublic'],
        data: value['data'],
        created: value['created']
    }
}
